import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentFacadeService } from './environment.facade.service';

@Injectable({
  providedIn: 'root',
})
export class LiteralsService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
  ) {}

  getLiterals(lang: string = 'en'): Observable<any> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/locale/findByLanguage?lang=${lang}`;
    return this.http.get(url, { withCredentials: true });
  }

  getAvailableLanguages(): Observable<any[]> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/locale/findAvailableLanguages`;
    return this.http.get<any[]>(url, { withCredentials: true });
  }
}
